var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from "react";
import { v4 } from "uuid";

function SvgFacilitet(_a, svgRef) {
  var title = _a.title,
      _titleId = _a.titleId,
      props = __rest(_a, ["title", "titleId"]);

  var titleId = _titleId !== null && _titleId !== void 0 ? _titleId : title ? "icon-title-" + v4() : undefined;
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7.268a2 2 0 01-1-1.733V2h-2.37a4.648 4.648 0 01-9.26 0H2v14h3.535a2 2 0 011.731 3.002 2 2 0 103.467 0A2 2 0 0112.466 16H16v-3.535a2 2 0 013.002-1.731 2 2 0 100-3.467 2 2 0 01-2.001 0zm-3.352-5.649v.001-.001zM18 1.059C18 .474 17.526 0 16.941 0h-4.12c-.701 0-1.174.887-1.174 1.588a2.647 2.647 0 01-5.294 0C6.353.887 5.88 0 5.179 0h-4.12C.474 0 0 .474 0 1.059V16.94C0 17.526.474 18 1.059 18h4.476a4 4 0 106.93 0h4.476c.585 0 1.059-.474 1.059-1.059v-4.476a4 4 0 100-6.93V1.06z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(SvgFacilitet);
export default ForwardRef;